export const UNIT_OF_MEASURE_EACHES = 'EA';
